module.exports = __webpack_public_path__ + "static/media/UHS_Logo_AgentPortal.22c6fcec.png";